import React from "react";
import { Link } from "react-router-dom";
const SchoolTiming = () => {
  return (
    <>
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academic </li>
          <li>School Timing & Schedule </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> School Timing & Schedule </h1>
            </div>
          </div>
          <div className="row tablebg">
            <div className="col-lg-6">
              <h6> School Timing </h6>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      {/* <th>Seasons</th> */}
                      <th> Grades Nursery -III </th>
                      <th> GRADES IV – XII</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {/* <td>Summer </td> */}
                      <td>08:55 AM – 12:45 PM</td>
                      <td>07:55 AM – 02:10 PM</td>
                    </tr>
                    {/* <tr>
                      <td>Winter </td>
                      <td>08:25 AM – 12:10 PM</td>
                      <td>08:25 AM – 02:10 PM</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
              <h6> Office Hours </h6>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>8:00 AM- 3:30 PM</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h6> Visiting Hour </h6>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Visit</th>
                      <th> Time </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        PRINCIPAL/MANAGER/ACADEMIC DIRECTOR (with Appointment)
                      </td>
                      <td>1:00 PM – 4:00 PM</td>
                    </tr>
                    <tr>
                      <td> Teacher (with Appointment) </td>
                      <td>2:00 PM – 3:00 PM</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                Reporting time at school for students have to be followed
                strictly. Reporting time is subject to change according to the
                season and parents are supposed to follow the directions through
                the circulars without fail.
              </p>
              <br />
              <h6>Vacations </h6>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Break</th>
                      <th> Grades & Dates </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td> Summer Break</td>
                      <td>
                        {" "}
                        Grades Nursery – VIII
                        <br />
                        (May 18 – June 30, 2026)
                        <br />
                        Grades IX – XII
                        <br />
                        (June 01 – June 30, 2026)
                      </td>
                    </tr>
                    <tr>
                      <td>Autumn Break </td>
                      <td>
                        Grades Nursery – XII
                        <br />
                        (October 19 – October 20, 2026)
                      </td>
                    </tr>
                    <tr>
                      <td> Diwali Break </td>
                      <td>
                        {" "}
                        Grades Nursery – XII
                        <br />
                        (November 07 – November 11, 2026)
                      </td>
                    </tr>
                    <tr>
                      <td>Winter Break </td>
                      <td>
                        Grades  I-XII
                        <br />
                        (January 01 – January 15, 2027)
                        <br />
                        Grades Nur–UKG
                        <br />
                        (January 01 – January 17, 2027)
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                <b>
                  There will be block classes for Grade IX-XII and Summer Camp
                  for Grades Nur-VIII from 18 May to 30 May 2026 (Timing:8.00
                  am-12 noon){" "}
                </b>
              </p>
              <p>
                <b>
                  {" "}
                  For the travel plans, parents are advised to confirm vacation
                  dates from the school because vacation dates are subject to
                  change as per exigency.
                </b>
              </p>
            </div>
            <div className="col-lg-6">
              <h6> Parent Teacher Meeting (PTM) Schedule </h6>
              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Month</th>
                      <th> Date </th>
                      <th> Grades </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      {" "}
                      <td> May 26 </td> <td> 23 May </td> <td>IX - XII</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> May 26 </td>
                      <td> 30 May</td> <td> NUR - VIII</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> July 26 </td> <td> 25 July </td>{" "}
                      <td> NUR-IV</td>{" "}
                    </tr>

                    <tr>
                      <td> August 26 </td> <td> 01 August</td>{" "}
                      <td>V-VIII</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td> October 26 </td> <td> 24 October </td>{" "}
                      <td> NUR - XII</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td rowSpan={2}> December 26</td>
                      <td>05 December </td> <td> X - XII</td>
                    </tr>
                    <tr>
                      {" "}
                      <td> 26 December</td> <td> NUR - XII</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td rowSpan={2}> February 27</td>
                      <td>06 February </td> <td> X, XII</td>
                    </tr>
                    <tr>
                      {" "}
                      <td> 27 February</td> <td> Result IX & XI</td>{" "}
                    </tr>
                    <tr>
                      {" "}
                      <td rowSpan={2}> March 27</td>
                      <td>30 March</td> <td> Result NUR- IV</td>
                    </tr>
                    <tr>
                      {" "}
                      <td> 31 March</td> <td>Result V,VIII</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p>
                We strongly recommend a healthy and adequate communication and
                co-operation between the parents and the teachers for the
                betterment of students. Therefore, the school will schedule PTM
                on the above dates to discuss the academics, human formation and
                other extra-curricular matters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolTiming;
